package com.fireavert.administration.yardi_integration_page.presentation

import com.fireavert.yardi.common_data.data_models.responses.YardiImportUnitDataResponse
import com.fireavert.yardi.shared.logic.data_models.YardiMiniCredentials

/**
 * Data class representing the view state for Yardi Property Import
 */
data class YardiPropertyImportViewState(
    val loading: Boolean = false,
    val error: String = "",

    // Step 1: Property Selection
    val propertyList: Map<String, Int> = emptyMap(),
    val availableCredentials: List<YardiMiniCredentials> = emptyList(),
    val yardiPropertyList: List<String> = emptyList(),

    // Step 2: Parsing Method
    val yardiUnitNames: List<String> = emptyList(),
    val dashboardUnitNames: List<String> = emptyList(),

    // Step 3: Import Process
    val importInProgress: Boolean = false,
    val importProgress: Float = 0f,
    val importStatus: String = "",
    val importId: String? = null,

    // Step 4: Results
    val importResults: ImportResults? = null,
    val yardiImportResponse: YardiImportUnitDataResponse? = null
)

/**
 * Data class for import results
 */
data class ImportResults(
    val totalUnitsProcessed: Int = 0,
    val successfulImports: Int = 0,
    val failedImports: Int = 0,
    val skippedUnits: Int = 0,
    val importSummary: List<ImportSummaryItem> = emptyList(),
    val errors: List<String> = emptyList(),
    val warnings: List<String> = emptyList(),
    val completedAt: String? = null
)

/**
 * Individual item in the import summary
 */
data class ImportSummaryItem(
    val unitName: String,
    val status: ImportStatus,
    val message: String,
    val yardiUnitId: String? = null,
    val dashboardUnitId: String? = null
)

/**
 * Status of individual unit import
 */
enum class ImportStatus {
    SUCCESS,
    FAILED,
    SKIPPED,
    WARNING
}